export default "__VITE_ASSET__B28WkoHq__"